<template>
<div class="sensor" :class="blockClass">
    <div class="sensor-position-block" :class="sensorIcon"></div>
    <div class="sensor-name-block">
        <div class="name-block">
            <router-link :to="{ name: 'sensor-settings', params: { id_group: id_group, id_sensor: sensor.id_sensor }}">
                {{sensorName}}
            </router-link>
        </div>
    </div>
    <div class="sensor-status-block">
        {{sensorStatus}}
    </div>
    <div class="sensor-icons-block">
        <div v-for="icon_element in getIcons" class="icon" :class="icon_element.class" :key="icon_element.type"
        data-toggle="tooltip" :title="icon_element.text">
        </div>
    </div>
    <div class="sensor-serial-number-block">
        ID {{sensorSerial}}
    </div>
    <div class="sensor-del-block">
        <b-btn class="icon cancel" :id="nameDelButtton" @click="del_popover = !del_popover"></b-btn>
    </div>
    <b-popover :show.sync="del_popover" :target="nameDelButtton" title="Удалить этот датчик" class="faucet-del-popover">
        <button type="button" class="btn btn-outline-danger" @click="deleteSensor">Да</button>
        <button type="button" @click="onCloseDelPopover" class="btn btn-outline-info">Нет</button>
    </b-popover>
</div>
</template>

<script>
import config from '@/config.js'
import axios from 'axios'
import {
    store
} from '@/store'

export default {
    name: 'sensor-row',
    created() {
        update_statuses(this)
    },
    data() {
        return {
            show: false,
            del_popover: false,
            id_group: this.$store.getters.id_group
        }
    },
    props: {
        sensor: Object
    },
    methods: {
        onCloseDelPopover() {
            this.del_popover = false
        },
        deleteSensor() {
            if (!!localStorage.token) {
                var post_data = new FormData()
                post_data.set('token', localStorage.token)
                post_data.set('id_sensor', this.sensor.id_sensor)
                var vue_obj = this
                axios({
                        method: 'POST',
                        url: config.API_HOST + '/sensors/delete_sensor',
                        data: post_data
                    })
                    .then(function (response) {
                        vue_obj.$emit('deleteRow')
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            }
        }
    },
    computed: {
        nameDelButtton: function () {
            return 'delSensor-' + this.sensor.id_sensor
        },
        sensorIcon: function () {
            if (this.sensor.status == 'warn') {
                return 'sensor-blob-attention'
            } else {
                return 'sensor-blob-ok'
            }
        },
        getIcons: function () {
            return update_statuses(this)
        },
        sensorName: function () {
            return this.sensor.name
        },
        sensorStatus: function () {
            var status = ''
            if (this.sensor.status == 'norm') {
                status = 'Норма'
            } else if (this.sensor.status == 'warn') {
                status = 'Тревога'
            } else if (this.sensor.status == 'none_connect') {
                status = 'Нет связи'
            }
            return status
        },
        sensorSerial: function () {
            var serial_number = this.sensor.serial_number.split("-").join("")
            serial_number = serial_number.toUpperCase()
            if (serial_number.length > 0) {
                serial_number = serial_number.match(new RegExp('.{1,4}', 'g')).join("-")
            }
            return serial_number
        },
        blockClass: function () {
            var class_name = ''
            if (!this.sensor.connection || this.sensor.status == 'none_connect') {
                class_name = 'sensor-gray-block'
            } else if (this.sensor.status == 'norm') {
                class_name = 'sensor-blue-block'
            } else if (this.sensor.status == 'warn') {
                class_name = 'sensor-red-block'
            }
            return class_name
        }
    }
}

function update_statuses(vue_obj) {
    var icons = []
    vue_obj.sensor.info_statuses.forEach(element => {
        var icon_class = false;
        var icon_text = null
        if (element >= 0 && element <= 5) {
            icon_text = "Питание от аккумулятора"
            if (element == 0) {
                icon_class = 'battery-cable-power'
                icon_text = "Питание от сети"
            } else if (element == 1) {
                icon_class = 'battery-1'
            } else if (element == 2) {
                icon_class = 'battery-2'
            } else if (element == 3) {
                icon_class = 'battery-3'
            } else if (element == 4) {
                icon_class = 'battery-4'
            } 
            // else if (element == 5) {
            //     icon_class = 'unknown-battery'
            // }

            if (icon_class) {
                icons.push({
                    text: icon_text,
                    type: 'battery',
                    class: icon_class
                })
            }
        } else if (element >= 10 && element <= 16) {
            icon_text = "Уровень сигнала"
            if (element == 16) {
                icon_class = false
            } else if (element == 10) {
                icon_class = 'signal-0'
            } else if (element == 11) {
                icon_class = 'signal-1'
            } else if (element == 12) {
                icon_class = 'signal-2'
            } else if (element == 13) {
                icon_class = 'signal-3'
            } else if (element == 14) {
                icon_class = 'signal-4'
            } else if (element == 15) {
                icon_class = 'signal-5'
            }

            if (icon_class) {
                icons.push({
                    text: icon_text,
                    type: 'signal',
                    class: icon_class
                })
            }
        }
    })
    return icons
}
</script>



// WEBPACK FOOTER //
// src/components/elements/sensor_row.vue